class Typography extends React.Component {
  render () {
    return (
      <li className="section__item">
        <h3 className="section__item-title" id="typography">
          Typography
          <span className="section__item-docs">
            Documentation: <a href="docs/scss#mixins-mixin-typography" target="_blank">SCSS</a>
          </span>
        </h3>
        <div className="section__demo">
         <Collapser>
            <div className="demo">
              <h4 className="demo__title">All typography options</h4>
              <div className="demo__code">
                <CodeBlock lang="html">
                {`
<div class="typography-demo">
  <h1>Hero</h1>
  <h2>Subhero</h2>
  <h3>xlHead</h3>
  <h4>lHead</h4>
  <h5>mHead</h5>
  <p className="lBody">lBody: The quick onyx goblin jumps over the lazy dwarf</p>
  <p className="mBody">mBody: The quick onyx goblin jumps over the lazy dwarf</p>
  <p className="copy">copy: The quick onyx goblin jumps over the lazy dwarf</p>
  <p className="code">code: The quick onyx goblin jumps over the lazy dwarf</p>
  <p className="host">host: The quick onyx goblin jumps over the lazy dwarf</p>
  <p className="presenter">presenter: The quick onyx goblin jumps over the lazy dwarf</p
</div>
                `}
                </CodeBlock>
                <CodeBlock lang="scss">
                {`
.typography-demo {
  h1 {
    @include hero;
    /* or @include typography(hero); (deprecated) */
  }

  h2 {
    @include subhero;
    /* or @include typography(subhero); (deprecated) */
  }

  h3 {
    @include xl-head;
    /* or @include typography(xlHead); (deprecated) */
  }

  h4 {
    @include l-head;
    /* or @include typography(lHead); (deprecated) */
  }

  h5 {
    @include m-head;
    /* or @include typography(mHead); (deprecated) */
  }

  .xlBody {
    @include xl-body;
    /* or @include typography(lBody); (deprecated) */
  }

  .lBody {
    @include l-body;
    /* or @include typography(lBody); (deprecated) */
  }

  .mBody {
    @include m-body;
    /* or @include typography(mBody); (deprecated) */
  }

  .copy {
    @include copy;
    /* or @include typography(copy); (deprecated) */
  }

  .highlighted {
    @include highlighted;
    /* or @include typography(highlighted); (deprecated) */
  }

  .code {
    @include typography;
    /* or @include typography(code); (deprecated) */
  }

  .host {
    @include host;
    /* or @include typography(host); (deprecated) */
  }

  .presenter {
    @include presenter;
    /* or @include typography(presenter); (deprecated) */
  }
}
                `}
                </CodeBlock>
              </div>
              <div className="demo__output">
                <Output>
                  <div className="typography-demo">
                    <h1>Hero</h1>
                    <h2>Subhero</h2>
                    <h3>xlHead</h3>
                    <h4>lHead</h4>
                    <h5>mHead</h5>
                    <p className="xlBody">xlBody: The quick onyx goblin jumps over the lazy dwarf</p>
                    <p className="lBody">lBody: The quick onyx goblin jumps over the lazy dwarf</p>
                    <p className="mBody">mBody: The quick onyx goblin jumps over the lazy dwarf</p>
                    <p className="copy">copy: The quick onyx goblin jumps over the lazy dwarf</p>
                    <p className="code">code: The quick onyx goblin jumps over the lazy dwarf</p>
                    <p className="host">host: The quick onyx goblin jumps over the lazy dwarf</p>
                    <p className="presenter">presenter: The quick onyx goblin jumps over the lazy dwarf</p>
                  </div>
                </Output>
              </div>
            </div>
          </Collapser>
        </div>
      </li>
    );
  }
};
